module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "x-2-chapter"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/SIDP_FM02_preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/SIDP_FM03_cast"
    }
  }, [_vm._v("Cast of Characters")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/SIDP_FM04_chronology"
    }
  }, [_vm._v("Chronology")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter1"
    }
  }, [_vm._v("Chapter One The Violent Stage")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/SIDP_02"
    }
  }, [_vm._v("Chapter Two The Owens Cadre")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SIDP_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three Blacks, Whites, Ropes")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SIDP_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four The Moonshine Glow")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SIDP_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five Life’s Contradictions")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SIDP_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six Pistol Claim Dispute")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SIDP_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven Posse Search")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SIDP_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight Mathis Eludes the Lawmen")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SIDP_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine An Arrest and Its Uproar")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SIDP_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten The Judge Faces the Accused")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SIDP_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven The Damning Testimony")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SIDP_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve Whit Owens Faces the Court")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SIDP_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen Preparing for Hangings")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SIDP_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen Owens and a New Venue")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SIDP_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen Father-in-Law Urges Suicide")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SIDP_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen Side by Side")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SIDP_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen Justice for White Owens")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SIDP_Biblio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")]), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "Basic-Text-Frame"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24614150","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 72
// module chunks = 0